import { spacing, styled, Text, mq } from '@thg-commerce/gravity-theme'
import {
  Button,
  ProductButton,
  PlatformMessage,
} from '@thg-commerce/gravity-elements'

export const Title = styled.p`
  ${Text('bodyText', 'default')}
  word-break: break-word;
`

export const StyledButton = styled(Button)`
  text-transform: none;
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
`

export const QuantityPlatformMessage = styled(PlatformMessage)`
  margin-bottom: ${spacing(1)};
`

export const OptionsButtonContainer = styled.div`
  display: none;
  flex-direction: column;
  width: 100%;
  gap: ${spacing(1)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    display: flex;
  }
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: none;
  }
  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    display: flex;
  }
`

export const MobileOptionButtonContainer = styled.div`
  display: flex;
  gap: ${spacing(2)};
  flex-direction: column;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    display: none;
  }
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: flex;
  }
  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    display: none;
  }
`

export const RecommendationItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing(3)};
`

export const StyledProductButton = styled(ProductButton)`
  width: 100%;
`

export const AttributeTitle = styled.span`
  ${Text('bodyText', 'alternate')}

  margin-right: ${spacing(1)};
`
